module.exports = __webpack_public_path__ + "img/india-logo-icon.7f30730e.png";